module.exports = __webpack_public_path__ + "static/media/science_stacked_bar.49cf0a19.png";